module.exports = __webpack_public_path__ + "img/u55.19626cf2.png";